/// <reference path="../../app.d.ts"/>
import { AppUtils } from '../../../../../shared/utils/index';
import { BasicApplicationRouter } from '../../../../../shared/services/BasicApplicationRouter';
import { AppPersistenceService } from './AppPersistenceService';

export class AppRouterService extends BasicApplicationRouter<FuelPricesUserFeedbackAppDefinition> {
	private readonly priceDetailsUrl: string;
	private readonly appPersistenceService: AppPersistenceService;

	constructor(options: BasicAppOptions<FuelPricesUserFeedbackAppDefinition>) {
		super(options);
		this.appPersistenceService = new AppPersistenceService(options);

		this.priceDetailsUrl = options.app.basedetailurl;
		if (options.app.detailurlsuffix) {
			const formModel = this.appPersistenceService.getFormModelFromStore();
			if (formModel.GasStation && formModel.GasStation.ID) {
				this.priceDetailsUrl = AppUtils.Url.combine(this.priceDetailsUrl, options.app.detailurlsuffix.interpolate({
					id: formModel.GasStation.ID,
					name: T.Utils.Helper.createSeoUrl(formModel.GasStation.Name || "station")
				}));
			}
		}
	}

	public get PriceDetailsUrl(): string {
		return this.priceDetailsUrl;
	}

	public priceDetails(): void {
		this.routeToLocation(this.priceDetailsUrl);
	}
}